export default __webpack_public_path__ + "static/media/45.2b1486b0.jpg";